// Utilitare de text comune (căutare, normalizare) — folosite de client și de server.

export function fold(s: string): string {
  return (s || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[șş]/g, 's').replace(/[țţ]/g, 't');
}

// cheie pentru a recunoaște „aceeași carte” (fără diacritice, spații, punctuație)
export function normalizeKey(s: string): string {
  return fold(s).replace(/[^a-z0-9]/g, '');
}

export interface ParsedQuery {
  text: string[];        // cuvinte libere (titlu, autor, ISBN, sinopsis)
  locations: string[];   // @raftliving
  tags: string[];        // #copii, #vinted, #beletristica
}

// „@living #copii prinț” → { locations:['living'], tags:['copii'], text:['print'] }
export function parseQuery(q: string): ParsedQuery {
  const out: ParsedQuery = { text: [], locations: [], tags: [] };
  for (const raw of (q || '').trim().split(/\s+/)) {
    if (!raw) continue;
    if (raw.startsWith('@') && raw.length > 1) out.locations.push(normalizeKey(raw.slice(1)));
    else if (raw.startsWith('#') && raw.length > 1) out.tags.push(normalizeKey(raw.slice(1)));
    else out.text.push(fold(raw));
  }
  return out;
}
